import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Rocket, Calendar } from "lucide-react";
import { Analytics } from "@/lib/analytics";
import { signupUrl } from "@/lib/productApp";
import CalendlyModal from "@/components/CalendlyModal";
import type { AdsMode } from "./AdsModeSelector";

const ctaContent = {
  vente: {
    title: "Pendant que vous lisez cette page, un prospect essaie de vous joindre.",
    subtitle: "Ne laissez plus vos concurrents répondre à votre place.",
    cta: "Démarrer maintenant",
  },
  location: {
    title: "Pendant que vous lisez cette page, des appels tombent dans le vide.",
    subtitle: "Laissez Immovox filtrer. Vous, gérez les bons dossiers.",
    cta: "Démarrer maintenant",
  },
};

const AdsCTA = ({ mode }: { mode: AdsMode }) => {
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  const c = ctaContent[mode];

  return (
    <>
      <section className="py-20 md:py-28 bg-primary relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-primary-foreground mb-4">
              {c.title}
            </h2>
            <p className="text-lg md:text-xl text-primary-foreground/80 mb-10 max-w-xl mx-auto">
              {c.subtitle}
            </p>

            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-foreground/15 text-primary-foreground text-sm font-semibold mb-6">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-foreground opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-foreground" />
              </span>
              7 jours d'essai gratuit
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                size="lg"
                className="h-auto py-4 md:h-16 px-6 md:px-10 bg-white text-primary font-bold text-sm md:text-lg rounded-full shadow-2xl hover:shadow-xl hover:bg-white/95 transition-all group max-w-full text-center whitespace-normal"
                asChild
              >
                <a
                  href={signupUrl()}
                  onClick={() => Analytics.ctaClicked("activer_filet", "ads_final_cta")}
                >
                  <Rocket className="w-5 h-5 mr-2 shrink-0" />
                  {c.cta}
                </a>
              </Button>

              <button
                className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                onClick={() => {
                  Analytics.ctaClicked("planifier_demo", "ads_final_cta");
                  setCalendlyOpen(true);
                }}
              >
                <Calendar className="w-3.5 h-3.5 inline mr-1" />
                Ou réserver une démo
              </button>
            </div>

            <p className="mt-5 text-sm text-primary-foreground/70">
              Sans engagement · Votre numéro ne change pas · Actif en 30 minutes
            </p>
          </div>
        </div>
      </section>
      <CalendlyModal open={calendlyOpen} onOpenChange={setCalendlyOpen} source="ads_final_cta" />
    </>
  );
};

export default AdsCTA;
